import React, { useRef }               from 'react';
import { useDispatch }                 from "react-redux";
import useClickOutside                 from "../../../hooks/useClickOutside";
import { triggerSettingsView }         from "../../../store/settings/actions";
import SettingsAlarmComponent          from "../SettingsAlramComponent";
import SettingsAudioComponent          from "../SettingsAudioComponent";
import SettingsClearTextComponent      from "../SettingsClearTextComponent";
import SettingsLanguageComponent       from "../SettingsLanguageComponent";
import SettingsLoadlastViewComponent   from "../SettingsLoadlastViewComponent";
import SettingsNotificationComponent   from "../SettingsNotificationComponent";
import SettingsPlaybackComponent       from "../SettingsPlaybackComponent";
import SettingsResponsivePaneComponent from "../SettingsResponsivePaneComponent";
import SettingsTimeComponent           from "../SettingsTimeComponent";
import SettingsTimeZoneComponent       from '../SettingsTimeZoneComponent';
import SettingsTitleComponent          from "../SettingsTitleComponent";
import StoreLocalSettingsComponent     from "../StoreLocalSettingsComponent";
import './style.scss';

// TODO
// Finish options implementation

const SettingsComponent = () => {
  const ref = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const onClose = () => {
    dispatch(triggerSettingsView(false))
  };

  useClickOutside(ref, onClose);

  return (
    <div className='pos-abs settings'
         ref={ref}
    >
      <SettingsTitleComponent onClose={onClose}/>
      <div className='scroll list-wrapper'>
        <StoreLocalSettingsComponent/>
        {/*<SettingsAudioComponent/>*/}
        <SettingsResponsivePaneComponent/>
        <SettingsTimeComponent/>
        <SettingsTimeZoneComponent/>
        {/*<SettingsPlaybackComponent/>*/}
        <SettingsLoadlastViewComponent/>
        <SettingsClearTextComponent/>
        <SettingsAlarmComponent/>
        <SettingsNotificationComponent/>
        {/*<SettingsLanguageComponent/>*/}
      </div>
    </div>
  )
};


export default SettingsComponent